import { type PropsWithChildren } from "react";
import { cx } from "class-variance-authority";

import * as styles from "./FilteredToggleGroup.module.scss";
import { Input } from "../Input/Input";

type FilteredToggleGroupProps = PropsWithChildren<{
  className?: string;
  label?: string;
}>;

const FilteredToggleGroup = ({
  className,
  children,
  label,
}: FilteredToggleGroupProps) => {
  return (
    <div className={cx(styles.filteredToggleGroup, className)}>
      <Input type="text" label={label} />

      {children}
    </div>
  );
};

FilteredToggleGroup.displayName = "FilteredToggleGroup";

export { FilteredToggleGroup };
